import BaseService from './BaseService.js'

export default {
  get(id) {
    return BaseService.get(`Entity/${id}`)
  },
  getByChange(id) {
    return BaseService.get(`Entity/Change/${id}`)
  },
  post(entity) {
    return BaseService.post(`Entity`, entity)
  },
  put(entity) {
    return BaseService.put(`Entity`, entity)
  },
  delete(id) {
    return BaseService.delete(`Entity/${id}`)
  },
  validate(changeId) {
    return BaseService.post(`Entity/Validate`, changeId)
  }
}
